export const CONTACT_FORM_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In progress" },
  { value: "closed", label: "Closed" },
] as const;

export type ContactFormStatus =
  (typeof CONTACT_FORM_STATUS_OPTIONS)[number]["value"];

export interface ContactFormPayload {
  full_name: string;
  mobile?: string;
  email?: string;
  subject?: string;
  message: string;
  status?: ContactFormStatus;
}

export interface ContactFormRecord {
  id: number;
  full_name: string;
  mobile?: string | null;
  email?: string | null;
  subject?: string | null;
  message: string;
  status: ContactFormStatus;
  created_at?: string;
  updated_at?: string;
}

export function formatContactFormStatusLabel(status?: string | null): string {
  const hit = CONTACT_FORM_STATUS_OPTIONS.find(o => o.value === status);
  return hit?.label ?? (status ? status.replace(/_/g, " ") : "—");
}

export function contactFormStatusClass(status?: string | null): string {
  switch ((status ?? "").toLowerCase()) {
    case "open":
      return "bg-blue-500/15 text-blue-700 hover:bg-blue-500/15";
    case "in_progress":
      return "bg-amber-500/15 text-amber-700 hover:bg-amber-500/15";
    case "closed":
      return "bg-muted text-muted-foreground hover:bg-muted";
    default:
      return "bg-muted text-muted-foreground hover:bg-muted";
  }
}
